import queryDuck from './ducks/query';

export const { getFilters } = queryDuck.selectors;
